import { axios } from './index'

export default {

  index(params) {
    return axios
      .get('get-property-by-availability-month-year', {
        params,
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  },
  show(id) {
    return axios
      .get(`show-website-property/${id}`)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  },
}
